module.exports = __webpack_public_path__ + "img/1.32_Russian_road_sign.c72290bc.svg";